
import React, { useState } from "react";
import { pushNotification } from '../../../../../utils/notifications';
import Modal from "react-bootstrap/Modal";
import QuanLyMauHopDongApi from "../../../../../service/QuanTriHeThong/QuanLyMauHopDong/QuanLyMauHopDongApi";

const ModalXoa = (props) => {
  const { show, onHide, Id, onDeleted } = props;
  const [isActiveSubmit, setIsActiveSubmit] = useState(false);

  const deleteContract = () => {
    setIsActiveSubmit(true);
    QuanLyMauHopDongApi.delete(Id).then((response) => {
      if (response.status === 200) {
        pushNotification("Xóa thành công!", "success", "TOP_CENTER", 2000);
        if (onDeleted) onDeleted();
      } else {
        pushNotification("Xóa thất bại!", "error", "TOP_CENTER", 2000);
        onHide();
      }
      setIsActiveSubmit(false);
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
             <i className="mdi mdi-delete" ></i>
          </span>
          Xác nhận xóa
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="form form-horizontal">
          <div className="form-body">
            <div className="form-body text-center">
              <p style={{fontSize: '16px'}}>Bạn có chắc chắn muốn xóa mẫu hợp đồng này?</p>
              <p className="canh-bao-red">Hành động này không thể hoàn tác.</p>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={onHide}
        >
          <span>
            <i className="mdi mdi-close"></i>
          </span>
          &nbsp; Hủy
        </button>

        <button 
          type="button" 
          className="btn btn-new-main btn-danger" 
          onClick={deleteContract} 
          disabled={isActiveSubmit}
        >
          <span>
            <i className="mdi mdi-delete" ></i>
          </span>
          &nbsp; Đồng ý xóa
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalXoa;
